import {TaskEditor} from "./TaskEditor";

export class LogNodeEditor extends TaskEditor {

	constructor(parent, node, coords) {
		super(parent, node, coords);
	}
}